import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";
// Self-hosted Nunito (variable, weight axis only) — bundled into dist, no runtime
// dependency on Google Fonts. Browsers lazy-load subsets via unicode-range.
import "@fontsource-variable/nunito/wght.css";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
